import * as React from 'react';
import { connect } from 'react-redux';
import { Popup } from 'semantic-ui-react';

import { StateType } from '../../reducers';
import { alphaShowDetailSelector } from '../../reducers/AlphasReducer/AlphasSelector';
import { addModifiers } from '../../shared/helpers';

interface PopupHoverIntentStateProps {
  showDetail: boolean;
}

interface PopupHoverIntentProps {
  modifiers: string[];
  onContentClick: () => void;
  stageClass: string;
  row: any;
}

interface PopupHoverIntentState {
  isOpen: boolean;
  isHovering: boolean;
}

class PopupHoverIntent extends React.Component<PopupHoverIntentStateProps & PopupHoverIntentProps, PopupHoverIntentState> {
  state = { isOpen: false, isHovering: false };

  openPopup = () => {
    setTimeout(() => {
      if (!this.props.showDetail && this.state.isHovering) {
        this.setState({ isOpen: true });
      }
    }, 1500);
  };

  closePopup = () => {
    this.setState({ isOpen: false });
  };

  handleIsHovering = () => {
    this.setState({ isHovering: true });
  };

  handleIsNotHovering = () => {
    this.setState({ isHovering: false });
  };

  render() {
    const { modifiers, onContentClick, stageClass, row } = this.props;

    return (
      <div onMouseLeave={this.handleIsNotHovering} onMouseEnter={this.handleIsHovering}>
        <Popup
          open={this.state.isOpen}
          size="mini"
          onClose={this.closePopup}
          onOpen={this.openPopup}
          trigger={
            <div className={addModifiers('alphas-list-table__cell-content', modifiers)} onClick={onContentClick}>
              <span className={stageClass}>
                {' '}
                {row.value.map((tag: any, index: number) => `${tag}${index !== row.value.length ? ', ' : ''}`)}
              </span>
            </div>
          }
          content={
            <span className={stageClass}>
              {' '}
              {row.value.map((tag: any, index: number) => `${tag}${index !== row.value.length ? ', ' : ''}`)}
            </span>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): PopupHoverIntentStateProps => ({
  // @ts-ignore
  showDetail: alphaShowDetailSelector(state),
});

export default connect<PopupHoverIntentStateProps, any, any, StateType>(mapStateToProps)(PopupHoverIntent);
